import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthColaborador } from '../../contexts/AuthColaboradorContext';
import NotificacoesBell from '../notifications/NotificacoesBell';

// Ícones SVG modernos
const Icons = {
  dashboard: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />,
  clock: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
  calendar: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />,
  doc: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />,
  file: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />,
  truck: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H3v-3a2 2 0 012-2h8m0 0V5a1 1 0 00-1-1H5a1 1 0 00-1 1v6m4 0h10a1 1 0 011 1v3m-3 0a2 2 0 11-4 0m8 0a2 2 0 11-4 0m-8-3h6m-6 3a2 2 0 11-4 0" />,
  fuel: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 22v-7.5m0 7.5h18M3 14.5V5a2 2 0 012-2h8a2 2 0 012 2v9.5m-12 0h12M15 5l4 1v6.5a2 2 0 01-2 2 2 2 0 01-2-2V9.5" />,
  wrench: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />,
  box: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />,
  users: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />,
  user: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />,
  money: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
  chart: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />,
  settings: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />,
  logout: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />,
  menu: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
};

const Icon = ({ name, className = "w-5 h-5" }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    {Icons[name]}
  </svg>
);

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const { colaborador, logout: logoutColaborador } = useAuthColaborador();
  const location = useLocation();

  const currentUser = colaborador || user;
  const currentLogout = colaborador ? logoutColaborador : logout;

  const menuSections = [
    {
      title: 'Principal',
      items: [
        { name: 'Dashboard', path: '/dashboard', icon: 'dashboard', profiles: ['administrador', 'supervisor', 'financeiro', 'limpeza', 'administrativo', 'coordenador'] },
        { name: 'Ponto Eletrônico', path: '/ponto', icon: 'clock', profiles: ['administrador', 'supervisor', 'financeiro', 'motorista', 'limpeza', 'administrativo', 'coordenador'] },
        { name: 'Histórico de Pontos', path: '/ponto/historico', icon: 'calendar', profiles: ['administrador', 'supervisor', 'financeiro', 'motorista', 'limpeza', 'administrativo', 'coordenador'] },
        { name: 'Folha de Ponto', path: '/ponto/folha', icon: 'doc', profiles: ['administrador', 'supervisor', 'financeiro', 'administrativo', 'coordenador'] },
        { name: 'Atestados', path: '/atestados', icon: 'file', profiles: ['motorista'] },
      ]
    },
    {
      title: 'Frota',
      items: [
        { name: 'Frota', path: '/frota', icon: 'truck', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'limpeza'] },
        { name: 'Abastecimentos', path: '/abastecimentos-financeiros', icon: 'fuel', profiles: ['supervisor', 'administrador', 'financeiro'] },
        { name: 'Veículos', path: '/frota/veiculos', icon: 'truck', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'limpeza'] },
        { name: 'Manutenções', path: '/frota/manutencoes', icon: 'wrench', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador'] },
        { name: 'Estoque', path: '/estoque', icon: 'box', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'administrativo'] },
        { name: 'Ordens de Serviço', path: '/frota/ordens-servico', icon: 'file', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'motorista'] },
      ]
    },
    {
      title: 'Gestão',
      items: [
        { name: 'RH', path: '/rh', icon: 'users', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'administrativo', 'motorista', 'auxiliar'] },
        { name: 'Colaboradores', path: '/rh/colaboradores', icon: 'user', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'administrativo', 'motorista', 'auxiliar'] },
        { name: 'Financeiro', path: '/financeiro', icon: 'money', profiles: ['administrador', 'financeiro'] },
        { name: 'Relatórios', path: '/relatorios', icon: 'chart', profiles: ['administrador', 'supervisor', 'financeiro', 'coordenador', 'administrativo', 'motorista', 'auxiliar'] },
        { name: 'Configurações', path: '/configuracoes', icon: 'settings', profiles: ['administrador'] },
      ]
    }
  ];

  const allMenuItems = menuSections.flatMap(s => s.items);
  const filteredSections = menuSections
    .map(section => ({
      ...section,
      items: section.items.filter(item => item.profiles.includes(currentUser?.perfil))
    }))
    .filter(section => section.items.length > 0);

  const mobileNavItems = allMenuItems
    .filter(item => item.profiles.includes(currentUser?.perfil))
    .slice(0, 4);

  const handleLogout = () => {
    currentLogout();
  };

  const iniciais = (currentUser?.nome || 'U').split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();

  const paginaAtual = allMenuItems.find(i => location.pathname === i.path)?.name || '';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar desktop */}
      <aside className="hidden lg:flex lg:w-72 lg:flex-col lg:fixed lg:inset-y-0 z-30">
        <div className="flex-1 flex flex-col min-h-0 bg-gradient-to-b from-indigo-950 via-indigo-900 to-indigo-950">
          <div className="flex-1 flex flex-col pt-6 pb-4 overflow-y-auto">
            {/* Logo */}
            <div className="px-6 flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-base shadow-lg shadow-indigo-900/50">
                TT
              </div>
              <div>
                <h1 className="text-xl font-bold text-white tracking-tight">TTAP</h1>
                <p className="text-[11px] text-indigo-300 font-medium uppercase tracking-widest">Transportes</p>
              </div>
            </div>

            {/* Menu por seções */}
            <nav className="mt-8 flex-1 px-4 space-y-6">
              {filteredSections.map((section, si) => (
                <div key={si}>
                  <p className="px-3 mb-2 text-[11px] font-semibold text-indigo-400 uppercase tracking-widest">
                    {section.title}
                  </p>
                  <div className="space-y-1">
                    {section.items.map((item) => {
                      const isActive = location.pathname === item.path;
                      return (
                        <Link
                          key={item.path}
                          to={item.path}
                          className={`${
                            isActive
                              ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-900/40'
                              : 'text-indigo-200 hover:bg-white/10 hover:text-white'
                          } group flex items-center px-3 py-2.5 text-sm font-medium rounded-xl transition-all duration-200`}
                        >
                          <span className={`mr-3 ${isActive ? 'text-white' : 'text-indigo-400 group-hover:text-white'}`}>
                            <Icon name={item.icon} className="w-[18px] h-[18px]" />
                          </span>
                          {item.name}
                          {isActive && (
                            <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white/90"></span>
                          )}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              ))}
            </nav>
          </div>

          {/* User info */}
          <div className="flex-shrink-0 border-t border-white/10 bg-white/5 backdrop-blur p-4">
            <div className="flex items-center w-full gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm shrink-0">
                {iniciais}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white truncate">{currentUser?.nome || 'Usuário'}</p>
                <p className="text-xs text-indigo-300 capitalize">{currentUser?.perfil || 'Perfil'}</p>
              </div>
              <button
                onClick={handleLogout}
                className="p-2 text-indigo-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                title="Sair"
              >
                <Icon name="logout" className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="lg:pl-72 flex flex-col min-h-screen">
        {/* Header */}
        <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-gray-200">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center gap-3">
                {/* Menu mobile */}
                <button
                  onClick={() => setSidebarOpen(true)}
                  className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                  title="Menu"
                >
                  <Icon name="menu" className="w-6 h-6" />
                </button>
                <div className="lg:hidden w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-sm">
                  TT
                </div>
                <div className="hidden sm:block">
                  <h1 className="text-lg font-bold text-gray-900">{paginaAtual || 'TTAP'}</h1>
                  <p className="text-xs text-gray-500 hidden md:block">
                    {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <NotificacoesBell />
                <div className="flex items-center gap-2 pl-3 border-l border-gray-200">
                  <div className="hidden md:block text-right">
                    <p className="text-sm font-medium text-gray-900 leading-tight">{currentUser?.nome?.split(' ')[0]}</p>
                    <p className="text-xs text-gray-500 capitalize leading-tight">{currentUser?.perfil}</p>
                  </div>
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm">
                    {iniciais}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1">
          <div className="px-4 sm:px-6 lg:px-8 py-6">
            {children}
          </div>
        </main>

        {/* Bottom nav mobile */}
        {mobileNavItems.length > 0 && (
          <nav className="lg:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-30 backdrop-blur-md bg-white/90">
            <div className="grid grid-cols-4">
              {mobileNavItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex flex-col items-center py-2.5 px-1 ${
                      isActive ? 'text-indigo-600' : 'text-gray-400'
                    }`}
                  >
                    <Icon name={item.icon} className="w-6 h-6" />
                    <span className="text-[10px] font-medium mt-0.5 truncate w-full text-center">{item.name}</span>
                  </Link>
                );
              })}
            </div>
          </nav>
        )}
      </div>

      {/* Menu mobile overlay */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="fixed inset-0 bg-black/50" onClick={() => setSidebarOpen(false)} />
          <div className="relative flex flex-col w-full max-w-xs h-full bg-gradient-to-b from-indigo-950 to-indigo-900">
            <div className="flex items-center justify-between p-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-sm">
                  TT
                </div>
                <span className="text-white font-bold text-lg">TTAP</span>
              </div>
              <button onClick={() => setSidebarOpen(false)} className="p-2 text-indigo-300 hover:text-white" aria-label="Fechar">
                ✕
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto px-4 pb-4 space-y-6">
              {filteredSections.map((section, si) => (
                <div key={si}>
                  <p className="px-3 mb-2 text-[11px] font-semibold text-indigo-400 uppercase tracking-widest">
                    {section.title}
                  </p>
                  <div className="space-y-1">
                    {section.items.map((item) => {
                      const isActive = location.pathname === item.path;
                      return (
                        <Link
                          key={item.path}
                          to={item.path}
                          onClick={() => setSidebarOpen(false)}
                          className={`${
                            isActive
                              ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white'
                              : 'text-indigo-200 hover:bg-white/10 hover:text-white'
                          } flex items-center px-3 py-2.5 text-sm font-medium rounded-xl transition-colors`}
                        >
                          <span className="mr-3"><Icon name={item.icon} className="w-[18px] h-[18px]" /></span>
                          {item.name}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              ))}
            </nav>
            <div className="p-4 border-t border-white/10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm">
                  {iniciais}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-white truncate">{currentUser?.nome || 'Usuário'}</p>
                  <p className="text-xs text-indigo-300 capitalize">{currentUser?.perfil}</p>
                </div>
                <button onClick={handleLogout} className="p-2 text-indigo-300 hover:text-white" title="Sair">
                  <Icon name="logout" className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Padding bottom para bottom nav mobile */}
      <div className="lg:hidden h-16"></div>
    </div>
  );
};

export default Layout;
